import { FunctionComponent, useCallback, useMemo } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { ChannelSwitcher, getWebAppUrl, useAppSelector } from '../../shared';
import { FooterAdmin } from '../FooterAdmin';
import { MenuAdmin } from '../MenuAdmin';

import classNames from 'classnames';
import classes from './SidebarAdmin.module.scss';

export const SidebarAdmin: FunctionComponent = () => {
  const { channels } = useAppSelector(({ channels }) => channels);

  const onChannelChange = useCallback(
    (channelId: number) => {
      const selectedChannel = channels
        .find(({ id }) => id === channelId)
        ?.subdomain.replace(/\s/g, '');

      if (!selectedChannel) {
        return;
      }

      window.location.replace(`${getWebAppUrl(selectedChannel)}/admin`);
    },
    [channels]
  );

  const renderChannelSwitcher = useMemo(() => Boolean(channels.length), [channels]);

  return (
    <div
      className={classNames(classes['sidebar'], {
        [classes['sidebar--mobile']]: isMobileOnly,
      })}
    >
      {renderChannelSwitcher && <ChannelSwitcher onChange={onChannelChange} />}
      <MenuAdmin />
      <FooterAdmin />
    </div>
  );
};
